import { render, staticRenderFns } from "./SASBTableMicro.vue?vue&type=template&id=35d90730&scoped=true"
import script from "./SASBTableMicro.vue?vue&type=script&lang=js"
export * from "./SASBTableMicro.vue?vue&type=script&lang=js"
import style0 from "./SASBTableMicro.vue?vue&type=style&index=0&id=35d90730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d90730",
  null
  
)

export default component.exports